import * as React from 'react';
import { cn } from '@restworld/utils-common';
export const Wrapper = ({ children, id }: WrapperProps) => <WrapperClass id={id}>{children}</WrapperClass>;
export default Wrapper;
const WrapperClass = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col gap-4', className)} {...props} />
);
export interface WrapperProps {
  children?: React.ReactNode;
  id?: string;
}
